<template>
  <div class="reward contents">
    <div class="intro">
      <h1 class="accessibilityHide">넥슨쇼핑 상품 추천하고 플레이포인트 적립</h1>
      <p class="accessibilityHide">친구에게 넥슨쇼핑 상품 링크 공유하고<br>친구가 구매하면 구매 금액의 일정 %를<br>플레이포인트로 드립니다.</p>
      <p class="accessibilityHide">상품 상세 페이지 공유하기 버튼에<br>가 있다면 리워드 프로그램 상품입니다.</p>
      <p class="accessibilityHide">공유하기를 클릭하면<br>상품의 적립율과 최대 적립 금액을 확인할 수 있어요</p>
      <p class="accessibilityHide">My > 리워드 프로그램 > 적립 상세 내역에서 적립된 포인트를 확인할 수 있고 ​적립된 포인트는 다음달 15일 지급됩니다. ​</p>
      <h2 class="accessibilityHide">[이용안내 및 유의사항]</h2>
      <ul class="accessibilityHide">
        <li>리워드 지급 대상 상품을 공유하고 상품을 공유 받은 친구가 쿠폰을 구매 후 사용해야 적립됩니다.​</li>
        <li>공유 상품당 한 명의 친구에게 적립 받을 수 있는 수량은 1개입니다.  (한명이 여러 개를 구매해도 1개 금액에 대해서만 적립)​</li>
        <li>본인이 공유하고 본인이 구매하는 경우, 다른친구가 구매했더라도 내가 사용하는 경우 포인트는 적립되지 않습니다. ​</li>
        <li>동일한 상품을 서로 공유하여 서로 적립 받은 포인트는 리워드 적립 금액에서 제외됩니다. ​</li>
        <li>부적절한 방법으로 적립한 것이 확인 될 경우 사전안내 없이 적립된 포인트는 회수 될 수 있습니다.​​</li>
      </ul>
      <img src="~@/assets/images/img_reward_intro.png" width="100%" alt="">
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss">
.reward {
  .intro {
    background: url("~@/assets/images/bg_reward_intro.png") repeat-x 0 0;
    background-size: 0.5px auto;
    img {
      display: block;
      margin: 0 auto;
      max-width: 360px;
    }
  }
}
</style>
